import { ReactElement } from 'react'
import { useAtom, useAtomValue } from 'jotai'
import { useNavigate } from 'react-router-dom'
import { modalStatusAtom, selectedAccountAtom } from 'store/atoms'

import getMFEConfig from 'helpers/getMFEConfig'
import { rewardsModalContainerId } from 'const/modalContainerId'
import routes from 'const/routes'
import { RewardsModal as RewardsMFEModal } from 'rewards-mfe'
import { triggerOnCloseAnalytics } from 'helpers/triggerOnCloseAnalytics'

const RewardsModal = (): ReactElement => {
  const [{ modalId, modalTriggerId }, updateModalStatus] =
    useAtom(modalStatusAtom)
  const selectedAccount = useAtomValue(selectedAccountAtom)
  const navigate = useNavigate()

  const mfeConfig = getMFEConfig('mfe')

  const handleCloseModal = (resetAnalytics?: boolean) => {
    updateModalStatus('', '')
    if (resetAnalytics) triggerOnCloseAnalytics()
  }

  const goToRewardsPage = () => {
    updateModalStatus('')
    setTimeout(() => {
      navigate(routes.REWARDS)
    }, 400)
  }

  return (
    <RewardsMFEModal
      containerId={rewardsModalContainerId(selectedAccount)}
      modalTriggerId={modalTriggerId}
      config={mfeConfig}
      isOpen={modalId === 'Rewards'}
      handleClose={handleCloseModal}
      goToRewardsPage={goToRewardsPage}
    />
  )
}
export default RewardsModal
